<template>
	
    <div style="display: none;">  <!--与上边距相差 20px的距离-->
      <el-row class="home" :gutter="20">
　　     <!--左边占据 8 -->
        <el-col :span="8">
          <!--上面个人信息-->
          <el-card shadow="hover" style="height: 282px">
            鼠标悬浮时显显示
          </el-card>
          <!--下面信息框-->
          <el-card shadow="hover" style="height: 320px;margin-top: 20px">
            鼠标悬浮时显显示
          </el-card>
        </el-col>
        <!--右边占据16-->
        <el-col :span="16">
          <!--6个显示指标 ￥ -->
          <div class="num">
            <el-card shadow="hover" v-for="(zhibiao,index) in zhibiaos" :key="index">
			  <div class="left_flex">
				  <i :class="zhibiao.tb"></i>
				  <p class="txt">{{zhibiao.name}}</p>
			  </div>
              
              <div class="detail">
                <p class="shuzi">{{zhibiao.num}}</p>
              </div>
            </el-card>
          </div>
		  
  
          <!--显示流程图-->
          <el-card shadow="hover">
            <div style="height: 280px"></div>
          </el-card>
        </el-col>
      </el-row>
    </div>
</template>

<script>
import '../../assets/css/cron.css';  //导入存放home的css文件

export default {
  name: "ConsWorkplace",
  data() {
    return {
      dialogTableVisible: false,
	  // https://cloud.tencent.com/developer/section/1489867   图标查看  https://blog.csdn.net/sps900608/article/details/90753997
	  zhibiaos: [{
	  	id: 1,             // 指标序号  暂时未用到
	  	name: '客户总数',   // 指标名称
	  	tb: 'icon el-icon-user',  // 指标图标
	  	num: 10                  // 指标值
	  }, {
	  	id: 2,
	  	name: '商机总数',
	  	tb: 'icon el-icon-view',
	  	num: 12
	  }, {
	  	id: 3,
	  	name: '项目总数',
	  	tb: 'icon el-icon-wallet',
	  	num: 300
	  }, {
	  	id: 4,
	  	name: '本年合同金额',
	  	tb: 'icon el-icon-money',
	  	num: 400
	  }, {
	  	id: 5,
	  	name: '本年成本费用',
	  	tb: 'icon el-icon-sold-out',
	  	num: 500
	  }, {
	  	id: 6,
	  	name: '本年回款金额',
	  	tb: 'icon el-icon-sell',
	  	num: 600
	  }],
    };
  },
  methods: {
  }
};
</script>
 

<style>
	.icon {
	   font-size: 30px;
	}
	.detail{
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		
	}
	.left_flex{
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		
	}
	.txt{
		margin-top: 5px;
		margin-left: 8px;
		font-size: 14px;
	}
	.shuzi{
		font-size: 24px;
		margin-top: 0px;
		margin-bottom: 0px;
		font-weight: 540;
		color: #00aa7f;
	}
</style>


